import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

interface GoogleMapsContextType {
    loaded: boolean;
}

const GoogleMapsContext = createContext<GoogleMapsContextType>({ loaded: false });

export const useGoogleMaps = () => useContext(GoogleMapsContext);

interface Props {
    apiKey: string;
    children: React.ReactNode;
}

export const GoogleMapsProvider: React.FC<Props> = ({ apiKey, children }) => {
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: apiKey,
        libraries: ['places'],
        id: 'google-maps-script',
    });

    // Ensure both the loader reports loaded AND the google object is actually available
    const loaded = isLoaded && typeof window !== 'undefined' && typeof (window as any).google !== 'undefined' && (window as any).google?.maps !== undefined;

    console.debug('useJsApiLoader', { isLoaded, loadError, loaded });

    return <GoogleMapsContext.Provider value={{ loaded }}>{children}</GoogleMapsContext.Provider>;
};
